<template>
<!--    外部这里新增加一个div-->
    <div class="progress-container">
<!--        里面不变的圈-->
        <div style="position:absolute;width: 100px;height: 100px;border: 2px solid #00f6ff;border-radius: 50%"></div>
        <svg class="progress-svg" width="200" height="200">
            <circle
                ref="progressCircle"
                class="progress-bar"
                cx="100"
                cy="100"
                :r="radius"
                fill="transparent"
                stroke="#4470a3"
                stroke-width="15"
            />
            <circle
                ref="progressCircle"
                class="progress-bar"
                cx="100"
                cy="100"
                :r="radius"
                fill="transparent"
                stroke="#00f6ff"
                stroke-width="15"
                stroke-linecap="round"
                :stroke-dasharray="dashArray"
                :stroke-dashoffset="dashOffset"
            />
        </svg>
        <!-- 默认是85分的文本 -->
        <div class="scoreText">{{ aiReportScore }}</div>
    </div>
</template>

<script>
// 引入动画库
import { ref, onMounted } from 'vue';
import gsap from 'gsap';
export default {
    setup() {
        const radius = 80; // 圆的半径 直接决定了圆的大小
        let aiReportScore = ref()
        let open = ref()

        // 计算 stroke-dasharray 和 stroke-dashoffset 的值
        let circumference = 2 * Math.PI * radius; // 圆的周长
        circumference = circumference-50
        const dashArray = `${circumference} ${circumference}`;
        const dashOffset = ref(circumference); // 初始值等于周长，表示0%的进度

        // let score = ref()

        onMounted(() => {

        });

        function load(){
            // 表示进度条的百分比
            let percent = (circumference*this.score)/100;
            // 使用GSAP创建圆形进度条动画
            gsap.to(dashOffset, {
                // dashOffset的值改变为下面这个
                value: circumference-percent,
                duration: 2, // 动画持续时间（秒）
                ease:"circ.out",
                // 动画在更新时被调用
                onUpdate: () => {
                    // 在动画更新时更新数值数据 综合得分
                    aiReportScore.value = calculateProgress(dashOffset.value, circumference);
                },
                onComplete: () => {
                    // 动画完成后的回调函数
                },
            });
        }
        // 计算进度百分比的函数
        const calculateProgress = (offset, total) => {
            const progress = 100 - (offset / total) * 100;
            return progress.toFixed(0); // 保留两位小数
        };

        function onclose(){
            open.value = false
            dashOffset.value = circumference
        }

        return {
            radius,
            dashArray,
            dashOffset,
            open,
            aiReportScore,
            onclose,
            load
        }
    }
}
</script>

<style scoped>
.progress-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;

}

.progress-svg {
    /*width: 19.53125vw;*/
    /*height: 19.53125vw;*/
    transform: rotate(90deg);
}

.progress-bar {
    transition: stroke-dashoffset 0.3s;
}

.scoreText {
    position: absolute;
    /*top: -106px;*/
    /*right: -70px;*/
    font-size: 6.9296875vw;
    color: #00f6ff;
    border-style: hidden;
}
</style>